import * as firebase from "firebase/app";
import "firebase/performance";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  // Add your config here
  apiKey: process.env.VUE_APP_FIREBASE_apiKey,
  authDomain: process.env.VUE_APP_FIREBASE_authDomain,
  databaseURL: process.env.VUE_APP_FIREBASE_databaseURL,
  projectId: process.env.VUE_APP_FIREBASE_projectId,
  storageBucket: process.env.VUE_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.VUE_APP_FIREBASE_messagingSenderId,
  appId: process.env.VUE_APP_FIREBASE_appId,
  measurementId: process.env.VUE_APP_FIREBASE_measurementId
};

if (process.env.NODE_ENV === "test") {
  // @ts-ignore
  firebase.initializeTestApp({
    projectId: "my-test-project",
    auth: { uid: "alice", email: "alice@example.com" }
  });
} else {
  firebase.initializeApp(firebaseConfig);
}
if (process.env.NODE_ENV === "production") {
  firebase.performance();
  firebase.analytics();
}
export const db = firebase.firestore();
if (process.env.VUE_APP_FIRESTORE_EMULATOR_HOST) {
  db.settings({
    host: process.env.VUE_APP_FIRESTORE_EMULATOR_HOST,
    ssl: false
  });
}
db.enablePersistence();

export const auth = firebase.auth();
export const storage = firebase.storage();
export const functions = firebase.app().functions("europe-west1");
if (process.env.VUE_APP_FIREBASE_FUNCTIONS_HOST) {
  functions.useFunctionsEmulator(
    `http://${process.env.VUE_APP_FIREBASE_FUNCTIONS_HOST}`
  );
}
